import { render, staticRenderFns } from "./merchantIncomeReport.vue?vue&type=template&id=10d4b9a6&"
import script from "./merchantIncomeReport.vue?vue&type=script&lang=js&"
export * from "./merchantIncomeReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports